import React, { useState } from 'react';
import { MdClose } from 'react-icons/md';
import CommentForm from './CommentForm';
import CommentItem from './CommentItem';

const CommentSection = ({
  comments,
  currentUser,
  onAddComment,
  onCommentLike,
  onAddReply,
  postId,
  onClose
}) => {
  const [showAllComments, setShowAllComments] = useState(false);

  const handleSubmitComment = (commentText) => {
    const newComment = {
      comment_id: Math.floor(Math.random() * 10000),
      comment: commentText,
      comment_user_name: currentUser.name,
      comment_user_profile: currentUser.profile_image,
      created_at: new Date().toISOString(),
      comment_likes: 0,
      has_liked_comment: false,
      replies: []
    };
    
    onAddComment(newComment);
  };

  return (
    <div className="border-t p-4">
      <CommentForm 
        currentUser={currentUser} 
        onSubmitComment={handleSubmitComment} 
      />
      
      <div className="flex items-center justify-between mb-3 px-2 mt-4">
        <div className="flex items-center">
          <h3 className="font-medium text-gray-800 text-[15px]">
            {comments.length} {comments.length === 1 ? "Comment" : "Comments"}
          </h3>
          {comments.length > 2 && !showAllComments && (
            <span className="ml-2 text-xs text-gray-500">
              ({comments.length - 2} hidden)
            </span>
          )}
        </div>
        
        <button
          onClick={onClose}
          className="text-sm text-gray-600 hover:text-gray-800 flex items-center group"
        >
          <span className="group-hover:bg-gray-100 p-1.5 rounded-full transition-all">
            <MdClose className="text-lg" />
          </span>
        </button>
      </div>

      <div className="space-y-4">
        {comments
          .slice(0, showAllComments ? comments.length : 2)
          .map((comment) => (
            <CommentItem
              key={comment.comment_id}
              comment={comment}
              currentUser={currentUser}
              onCommentLike={onCommentLike}
              onAddReply={onAddReply}
              postId={postId}
            />
          ))}

        {comments.length > 2 && (
          <div className="pt-2">
            <button
              onClick={() => setShowAllComments(!showAllComments)}
              className="w-full text-center text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors"
            >
              <div className="inline-flex items-center px-4 py-1.5 rounded-full hover:bg-gray-100 transition-all">
                {showAllComments ? (
                  <>
                    <span className="mr-1">↑</span>
                    Show fewer comments
                  </>
                ) : (
                  <>
                    <span className="mr-1">↓</span>
                    Show {comments.length - 2} more{" "}
                    {comments.length - 2 === 1 ? "comment" : "comments"}
                  </>
                )}
              </div>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentSection;